import DataTable from 'react-data-table-component'
import {useEffect, useMemo, useState, useRef} from 'react'
import {
  fetchData,
  formatDatePublic,
  getEncryptedRoute,
  toasterrormsg,
  toastsuccessmsg,
  useMenuIdPermissions,
} from '../../../../reusable'

import 'react-datepicker/dist/react-datepicker.css'
import {Link, useLocation} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import Swal from 'sweetalert2'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faEdit, faTrash} from '@fortawesome/free-solid-svg-icons'
import { Tr } from '../../../../_metronic/i18n/Tr'
import { KTIcon, toAbsoluteUrl } from '../../../../_metronic/helpers'

function ViewRoles() {
  let t = Tr()
  const {menuIdAdd, menuIdEdit, menuIdDelete,menuId} = useMenuIdPermissions()

  const [rolesList, setRolesList] = useState([])
  const [orgRolesList, setOrgRolesList] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState(0)


  // Define your DataTable columns
  const column = useMemo(
    () => [
      {
        name: t('Role Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.roleName}</div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => String(row.roleName),
      },
      {
        name: t('Created At'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.created ? formatDatePublic(row.created) : '-'}</div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => String(row.created),
      },
      {
        name: t('Action'),
        cell: (row: any) => (
          <>
            {row.roleId != '1' ? (
              <>
                {menuIdEdit ? (
                  <Link
                    to={getEncryptedRoute('../addrole', {menuId : menuId , roleId : row.roleId})}
                    className='btn me-2 btn-icon btn-wave waves-effect waves-light btn-sm btn-success-light'
                    title='Edit'
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </Link>
                ) : (
                  ''
                )}

                {menuIdDelete ? (
                  <button
                    className='btn btn-icon btn-wave waves-effect waves-light btn-sm btn-primary-light me-2'
                    title='delete'
                    onClick={() => deleteRolesRights(row.roleId)}
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </button>
                ) : (
                  ''
                )}
              </>
            ) : (
              <div className='badge badge-danger p-2 badge-sm'>{t("Not Editable")}</div>
            )}
          </>
        ),
      },
    ],
    [t]
  )

  const deleteRolesRights = async (roleId: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t('You Want To Delete This Role!'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('Ok'), // Custom OK button text
      cancelButtonText: t('Cancel'), // Custom Cancel button text
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          var param: any = {
            roleId: String(roleId),
          }

          const response = await fetchData('admin/deleterole', param)

          if (response.status == '200') {
            toastsuccessmsg(response.message)
            rolesListApiCall()
          } else {
            toasterrormsg(response.message)
          }
        } catch (error) {
          toasterrormsg('An error occurred while processing your request.')
        }
      }
    })
  }

  // call roles subject list api
  const rolesListApiCall = async () => {
    var param: any = {}
    var response: any = await fetchData('admin/viewrole', param)

    if (response.status == '200') {
      let data = response.data
      
      setRolesList(data)
      setOrgRolesList(data)
    } else {
      toasterrormsg(response.message)
    }
  }

  useEffect(() => {
    document.title = 'Insayr | View Roles'
    rolesListApiCall()
  }, [])

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.customSearch(e, 1)
      // inputRef.current.focus();
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])
    return (
      <div className='row d-flex justify-content-between w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 col-lg-4'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search Roles & Rights')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
        <div className='d-flex justify-content-end col-xl-8 ' data-kt-user-table-toolbar='base'>
      { menuIdAdd ?   <Link
            className='btn btn-success monthBtn text-white h-40px'
            id='kt_toolbar_primary_button'
            to={getEncryptedRoute('../addrole', {menuId :menuId})}
          >
            + {t('Add Role & Right')}
          </Link> :""}
        </div>
      </div>
    )
  }

  //search function
  const rolesAndRIghtsSearch = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    if (text == '' || text == null || text == undefined) {
      setRolesList(orgRolesList)
    } else {
      var tmp: any = orgRolesList.filter(
        (item: any) =>
          (item.en_name != null &&
            item.en_name != '' &&
            item.en_name.toLowerCase() == text.toLowerCase()) ||
          (item.en_name != null &&
            item.en_name != '' &&
            item.en_name.toLowerCase().includes(text.toLowerCase())) ||
          (item.ru_name != null && item.ru_name != '' && item.ru_name == text) ||
          (item.ru_name != null && item.ru_name != '' && item.ru_name.includes(text)) ||
          (item.uz_name != null && item.uz_name != '' && item.uz_name == text) ||
          (item.uz_name != null && item.uz_name != '' && item.uz_name.includes(text))
      )

      setRolesList(tmp)
    }
  }

  return (
    <>
      <ToastContainer />
      <div className='container-fluid'>
        <div className='row mt-5'>
          <div className='col-12'>
            {orgRolesList.length > 0 ? (
              <>
                <DataTable
                  columns={column}
                  data={rolesList}
                  pagination
                  paginationServer={false}
                  subHeader={true}
                  subHeaderComponent={
                    <CustomHeader
                      search={searchTerm}
                      isfoc={focus}
                      customSearch={rolesAndRIghtsSearch}
                    />
                  }
                  paginationComponentOptions={{
                    rowsPerPageText: t('Rows Per Page'),
                  }}
                />
              </>
            ) : (
              <>
                <div className='text-center px-4'>
                  <div className='d-flex justify-content-center align-items-center flex-column mt-10 pt-20 pb-2 mb-2'>
                    <h2 className='fs-2x fw-bold'>{t('Welcome To Roles')}</h2>
                  </div>
                  <p className='text-gray-400 fs-4 fw-semibold'>{t('There are no Roles')}</p>
                 {menuIdAdd ? <Link
                    to={getEncryptedRoute('../addrole', {menuId :menuId})}
                    className='btn btn-success monthBtn'
                  >
                    {t('Add Role')}
                  </Link> :""}
                  <br />
                </div>
                <div className='d-flex justify-content-center'>
                  <img
                    className='mw-100 mh-300px'
                    alt=''
                    src={toAbsoluteUrl('/media/illustrations/sketchy-1/2.png')}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default ViewRoles
